<template>
    <v-list>
        <v-list-item>
            <v-list-item-title>Мои пространства</v-list-item-title>
        </v-list-item>
        <v-list-item link
            v-for="(workspace) in LIST_WORKSPACES"
            :key="workspace.id"
            @click="onChangeWorkSpace(workspace.id)"
        >
            <v-list-item-icon>
                <v-icon v-if="workspace.id === ID_WORK_SPACE" size="28">mdi-check</v-icon>
            </v-list-item-icon>
            <v-list-item-avatar
                size="28"
                class="mr-2"
                :color="getColorAvatar(workspace)"
            >
                <v-img v-if="workspace.avatar" :src="'/avatars/' + workspace.avatar"></v-img>
                <span v-else class="white--text text-h5" >{{workspace.name.slice(0,1)}}</span>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>
                    {{ workspace.name }}
                </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action v-if="workspace.id === ID_WORK_SPACE"
                                @click="() => IS_OWNER ? $router.push({name: 'workSpace.settings'}).catch(()=>{}) : $router.push({name: 'work_space'}).catch(()=>{})">
                <v-btn icon v-if="IS_OWNER">
                    <v-icon size="28">mdi-cog</v-icon>
                </v-btn>
                <v-btn icon v-else>
                    <v-icon size="28">mdi-account-multiple</v-icon>
                </v-btn>
            </v-list-item-action>

            <v-list-item-action v-if="!workspace.is_participant_work_space">
                <v-btn icon>
                    <v-icon size="28">mdi-email-plus-outline</v-icon>
                </v-btn>
            </v-list-item-action>
        </v-list-item>
        <v-list-item link @click="showWorkSpaceCreateModal">
            <v-list-item-title>Создать</v-list-item-title>
            <v-list-item-icon>
                <v-icon color="green" >mdi-plus-outline</v-icon>
            </v-list-item-icon>
        </v-list-item>
    </v-list>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'WorkspacesList',
    components: {},
    props:{
    },
    mounted(){

    },
    data(){
        return {
        }
    },
    methods: {
        getColorAvatar(ws){
            const colors = ['primary', 'purple', 'deep-purple', 'orange', 'cyan', 'teal', 'green', 'yellow', 'grey'];
            if(ws.avatar){
                return '';
            }
            return colors[Math.floor((Math.random()*colors.length))];

        },
        onChangeWorkSpace(id){
            if(id === this.ID_WORK_SPACE){
                return;
            }
            if(false === this.IS_PARTICIPANT_WORK_SPACE(id)){
                this.SET_INVITE_WORKSPACE_BY_ID(id).then(() => {
                    this.showWorkSpaceInviteModal();
                });
                return;
            }
            this.CHECKOUT(id).then(() => this.LOAD_WORKSPACES());
        },
        ...mapActions('workspaceList', ['LOAD_WORKSPACES', 'SET_INVITE_WORKSPACE_BY_ID']),
        ...mapActions('workspace', ['CHECKOUT']),
        ...mapActions('dialog', ['showWorkSpaceCreateModal', 'showWorkSpaceInviteModal']),
    },
    computed:{
        ...mapGetters('workspaceList', ['LIST_WORKSPACES', 'ID_CURRENT_WORKSPACE', 'IS_PARTICIPANT_WORK_SPACE']),
        ...mapGetters('workspace', ['ID_WORK_SPACE', 'IS_OWNER']),
    },
}
</script>